export default __webpack_public_path__ + "static/media/can.d580c6b2.svg";